import React from 'react';
import styled from 'styled-components';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

class FormImpor11  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fechaCorte: null,
            opcion: 'A',
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impImportacionSaldoTransito = this.impImportacionSaldoTransito.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0311')
         ])
        .then(() => {
            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('03');
            this.setState({fechaCorte: moment(fechaProceso,'DD/MM/YYYY')})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0311');
    }

    limpiar(){
        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('03');
        this.setState({fechaCorte: moment(fechaProceso,'DD/MM/YYYY'), opcion: 'A'})
    }

    impImportacionSaldoTransito(){
        var continuar = true;
        var error = "";

        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('03');
        var fechaValid = moment(fechaProceso,'DD/MM/YYYY');

        if(this.state.fechaCorte.diff(fechaValid, 'days')){
            continuar = false;
            error=error+'- La fecha de corte debe ser menor a: '+formatearFechaMoment_a_String(fechaValid)+'\n';
        }

        if(continuar === true){
            let parametros = ""
            parametros = '&rpt=53&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)+'&param2='+this.state.opcion;
            visualizarReporteEnPdf(parametros);
        }else{
            alert(error)
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Saldo Importación en Tránsito</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                                <LabelForm>Fecha Corte:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5 col-sm-offset-4 col-sm-pull-4' margen_arriba='15' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fechaCorte} func_onChange={(fechaEscogida)=>{this.setState({fechaCorte: fechaEscogida});}}/>
                            </ContainerCol>                            
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>                                                        
                            <ContainerCol className='col-sm-3' margen_abajo='4'>
                                <LabelForm>Opción:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-9' margen_abajo='4'>
                                <LabelSub><Radio name="opcion" type='radio' disabled={false} value='A' onChange={this.changeComponents} checked={this.state.opcion==='A'?true:false}/>{' Abiertos'}</LabelSub>
                                <LabelSub><Radio name="opcion" type='radio' disabled={false} value='L' onChange={this.changeComponents} checked={this.state.opcion==='L'?true:false}/>{' Liquidados'}</LabelSub>
                                <LabelSub><Radio name="opcion" type='radio' disabled={false} value='X' onChange={this.changeComponents} checked={this.state.opcion==='X'?true:false}/>{' Anulados'}</LabelSub>
                            </ContainerCol>                             
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                            <br/>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.fechaCorte===null?true:false} onClick={()=>{this.impImportacionSaldoTransito('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor11);